const messages: Record<string, string> = {
	'blockedByDevice.headline': 'Utilizați un smartphone',
	'blockedByDevice.paragraph.first':
		'Acest link poate fi utilizat exclusiv de pe un smartphone. Scanați codul QR de mai jos cu smartphone-ul dumneavoastră pentru a începe procesul.',
	'blockedByDevice.paragraph.second':
		'Un sfat rapid: atunci când deschideți linkul, asigurați-vă că vă aflați lângă vehicul și că aveți documentele pregătite.',
	'button.continue': 'Continua',
	'button.next': 'Continua',
	'button.photo.take': 'Faceti o fotografie',
	'onboardingStart.headline': 'Salut! Verificați informațiile dumneavoastră pentru a putea începe.',
	'onboardingStart.plateNumber': 'Număr de înmatriculare:',
	'onboardingStart.timeout': 'Acest link va fi activ până la ',
	'button.start': 'Începeți',
	poweredBy: 'Furnizat de <ce>ControlExpert</ce>, Companie din grupul <solvd>Solvd</solvd>',
	'onboarding.headline': 'Sunteți gata să începeți inspecția digitală?',
	'onboarding.paragraph': 'Înainte de a începe procesul, vă rugăm să aveți în vedere următoarele:',
	'onboarding.documents':
		'Aveți la îndemână cheile și certificatul de înmatriculare al vehiculului.',
	'onboarding.camera': 'Fotografiile pot fi realizate numai cu ajutorul camerei smartphone-ului.',
	'onboarding.internet':
		'Asigurați-vă că vă aflați într-un loc bine iluminat și cu o conexiune bună la internet.',
	'onboarding.vehicle':
		'Asigurați-vă că vehiculul este curat, accesibil din toate unghiurile și că toate geamurile sunt închise.',
	'onboarding.terms.before': 'Înainte de a începe, vă rugăm să confirmați următoarele:',
	'onboarding.terms.url': 'Sunt de acord cu <tclink>Termenii și condițiile</tclink>.',
	'loader.error':
		'Procesul dumneavoastră nu a putut fi încărcat. Vă rugăm încercați din nou mai târziu...',
	'loader.loading': 'Se încarcă datele...',
	'vehicleFrontLeftPerspectiveImage.title': 'Fotografie a vehiculului din față-stânga',
	'vehicleFrontLeftPerspectiveImage.description':
		'Faceți o fotografie din diagonală față-stânga, asigurându-vă că întregul vehicul este încadrat în imagine și că numărul de înmatriculare este vizibil.',
	'vehicleRearLeftPerspectiveImage.title': 'Fotografie a vehiculului din spate-stânga',
	'vehicleRearLeftPerspectiveImage.description':
		'Faceți o fotografie din diagonală spate-stânga, asigurându-vă că întregul vehicul este încadrat în imagine și că numărul de înmatriculare este vizibil.',
	'vehicleRearRightPerspectiveImage.title': 'Fotografie a vehiculului din spate-dreapta',
	'vehicleRearRightPerspectiveImage.description':
		'Faceți o fotografie din diagonală spate-dreapta, asigurându-vă că întregul vehicul este încadrat în imagine și că numărul de înmatriculare este vizibil.',
	'vehicleFrontRightPerspectiveImage.title': 'Fotografie a vehiculului din față-dreapta',
	'vehicleFrontRightPerspectiveImage.description':
		'Faceți o fotografie din diagonală față-dreapta, asigurându-vă că întregul vehicul este încadrat în imagine și că numărul de înmatriculare este vizibil.',
	'windshieldImage.title': 'Fotografie a parbrizului',
	'windshieldImage.description':
		'Realizați o fotografie a parbrizului, asigurându-vă că întreaga suprafață a geamului și toate detaliile acestuia sunt clar vizibile.',
	'vinPicture.title': 'Fotografie a numărului de identificare al vehiculului (VIN)',
	'vinPicture.description':
		'Realizați o fotografie de aproape a zonei în care este inscripționat Numărul de Identificare al Vehiculului (VIN), asigurându-vă că toate caracterele sunt lizibile.',
	'button.hint': 'Unde este amplasat numărul VIN (serie caroserie)?',
	'hint.vin.title': 'Posibile locatii ale VIN - ului (serie caroserie)',
	'hint.vin.description': 'Acesta poate fi amplasat in urmatoarele locatii:',
	'hint.vin.location1': 'Pe plansa de board vizibi prin parbriz pe partea soferului.',
	'hint.vin.location2': 'Pe rama ușii șoferului, în apropierea închizătorii.',
	'hint.vin.location3': 'La compartimentul motor, adesea pe o plăcuță metalică.',
	'hint.vin.location4': 'Pe partea frontală a șasiului (la vehiculele mai vechi).',
	'overallDashboardImage.title': 'Fotografie de ansamblu a bordului',
	'overallDashboardImage.description':
		'Realizați o fotografie de ansamblu a bordului, asigurându-vă că toate comenzile și elementele acestuia sunt complet vizibile.',
	'dashboardMileage.title': 'Fotografie a kilometrajului',
	'vehicleMileage.description':
		'Realizați o fotografie a kilometrajului, asigurându-vă că afișajul digital este clar focalizat și complet lizibil.',
	'dashboardMileage.paragraph.first': 'Introduceti kilometrajul vehiculului',
	'dashboardMileage.placeholder.updated': 'Introduceți kilometrajul (km)',
	'additionalDamagePictures.title': 'Fotografii ale avariilor',
	'damagedImages.booleanRadioGroupLabel': 'Vehiculul dumneavoastră prezintă avarii?',
	'damagedImages.description': 'Puteți adăuga până la {imageCount, number} fotografii.',
	'damagedImages.booleanRadioGroupLabelLeft': 'Nu',
	'damagedImages.booleanRadioGroupLabelRight': 'Da',
	'thanks.headline.first': 'Fotografiile au fost primite cu succes!',
	'thankYou.message':
		'Solicitarea dumneavoastră este în curs de analiză de către echipa noastră tehnică.',
	'feedback.title': 'Am aprecia feedback-ul dumneavoastră.',
	'feedback.message':
		'Pe o scară de la 0 la 5, cum ați evalua experiența dumneavoastră privind efectuarea inspecției digitale la noi?',
	'feedback.helpImprove': 'Ajutați-ne să ne îmbunătățim serviciile (opțional):',
	'feedback.button.send': 'Trimiteți opinia',
	'feedback.error.maxLength': 'Feedback-ul nu poate depăși 500 de caractere.',
	'review.title': 'Rezumatul inspecției digitale',
	'review.paragraph.first':
		'După ce apăsați pe „Finalizează”, vom confirma fotografiile și informațiile furnizate.',
	'review.stepDescription.questions': 'Informații despre vehicul',
	'review.stepDescription.group.perspectiveImages': 'Fotografii de ansamblu ale vehiculului',
	'review.stepDescription.group.additionalImages': 'Fotografii suplimentare',
	'review.stepDescription.damageImages': 'Fotografii ale avariilor',
	'review.stepDescription.fourAdditionalDocuments': 'Detalii vehicul',
	'review.stepDescription.vehicleRegistrationDocument':
		'Certificatul de înmatriculare al vehiculului',
	'review.stepDescription.registrationDocument':
		'Fotografie a certificatului de înmatriculare (față)',
	'review.stepDescription.registrationDocumentInside':
		'Fotografie a certificatului de înmatriculare (verso)',
	'review.button.next': 'Finalizează',

	'review.stepDescription.vehicleFrontLeftPerspective': 'Fotografie a vehiculului din față-stânga',
	'review.stepDescription.vehicleRearLeftPerspective': 'Fotografie a vehiculului din spate-stânga',
	'review.stepDescription.vehicleRearRightPerspective':
		'Fotografie a vehiculului din spate-dreapta',
	'review.stepDescription.vehicleFrontRightPerspective':
		'Fotografie a vehiculului din față-dreapta',

	'review.stepDescription.windshield': 'Fotografie a parbrizului',
	'review.stepDescription.vinPicture':
		'Fotografie a numărului de identificare al vehiculului (VIN)',
	'review.stepDescription.overallDashboard': 'Fotografie de ansamblu a bordului',
	'review.stepDescription.mileage': 'Fotografie a kilometrajului',

	'timeout.headline.first': 'Cazul solicitat nu a fost găsit.',
	'timeout.paragraph.first': 'Cazul dumneavoastră a expirat sau linkul accesat este incorect.',
	'vehicleRegistrationDocument.title': 'Detalii vehicul',
	'vehicleRegistrationDocument.RegistrationDocument.title':
		'Fotografie a certificatului de înmatriculare (față)',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Realizați o fotografie a certificatului de înmatriculare (față).',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title':
		'Fotografie a certificatului de înmatriculare (verso)',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Realizați o fotografie a certificatului de înmatriculare (verso).',
	'photoUploading.title': 'Încărcare',
	'photoAnalyzing.title': 'Analizare',
	'photoLoading.title': 'Se încarcă',
	'camera.darkWarning':
		'Mediul este posibil să fie prea întunecat. Vă rugăm să îmbunătățiți iluminarea pentru o calitate mai bună a fotografiilor.',
	'landscapeModeDetected.title': 'Rotire automată activată',
	'landscapeModeDetected.text':
		'Pentru o experiență mai bună la utilizarea camerei, vă rugăm să dezactivați funcția de rotire automată a dispozitivului.',
	'validationContainer.correct': 'Corect',
	'button.changeImage': 'Schimbă fotografia',
	'button.acceptImage': 'Acceptă fotografia',
	'button.acceptMileage': 'Corect',
	'button.anotherImage': 'Faceți o altă fotografie',
	'invalidFile.size.title': 'Dimensiune incorectă a fotografiei',
	'invalidFile.size.description': 'Dimensiunea fotografiei depășește limita maximă permisă.',
	'invalidFile.extension.title': 'Tip de fișier nesuportat',
	'invalidFile.extension.description':
		'Tipul de fișier specificat nu este acceptat. Tipuri de fișiere acceptate: .jpg, .jpeg, .jfif, .heic, .heif, .png și .bmp.',
	'connectionError.title': 'Eroare de conexiune',
	'connectionError.description': 'Eroare de conexiune. Vă rugăm să încărcați fotografia din nou.',
	'missingPhoto.title': 'Fotografie lipsă',
	'missingPhoto.description':
		'Se pare că lipsește o fotografie. Vă rugăm să adăugați fotografia lipsă pentru a continua.',
	'serviceErrorModal.headline': 'Unexpected error occured',
	'serviceErrorModal.close': 'OK',

	'serviceErrorModal.paragraph.first': 'Unexpected error has occured, please reload the page.',
	'serviceErrorModal.paragraph.second': 'If the error is persistent, reach out for support.',
	'serviceErrorModal.paragraph.details':
		'Please share any additional detail (e.g., screenshot) that could help us reproduce the error.',
};

export default messages;
